import { intToPx } from '@pkg/utils';

import { breakpoints } from './breakpoints';
import { type MediaQueryConditions, MediaQueryTarget } from './types';

const MIN_WIDTH = {
    phablet: intToPx(breakpoints.phablet),
    tablet: intToPx(breakpoints.tablet),
    desktop: intToPx(breakpoints.desktop),
    widescreen: intToPx(breakpoints.widescreen),
    quadHdY: intToPx(breakpoints.quadHdY),
    ultrawide: intToPx(breakpoints.ultrawide),
};

export const mediaQueries: MediaQueryConditions = {
    [MediaQueryTarget.Phablet]: `(min-width: ${MIN_WIDTH.phablet})`,
    [MediaQueryTarget.Tablet]: `(min-width: ${MIN_WIDTH.tablet})`,
    [MediaQueryTarget.Desktop]: `(min-width: ${MIN_WIDTH.desktop})`,
    [MediaQueryTarget.Widescreen]: `(min-width: ${MIN_WIDTH.widescreen})`,
    [MediaQueryTarget.QuadHdY]: `(min-width: ${MIN_WIDTH.quadHdY})`,
    [MediaQueryTarget.Ultrawide]: `(min-width: ${MIN_WIDTH.ultrawide})`,
    [MediaQueryTarget.Landscape]: '(orientation: landscape)',
    [MediaQueryTarget.PrefersReducedMotion]: '(prefers-reduced-motion: reduce)',
    [MediaQueryTarget.UsingMouse]: '(pointer: fine)',
};
